(function () {
    'use strict';

    angular
        .module('committeeModule', [
        ]);
})();